
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"info_one":"Eine Zeile ausgewählt","info_other":"{{count}} Zeilen ausgewählt","buttonText":"Auf Zeile(n) filtern"},"en":{"info_one":"One row selected","info_other":"{{count}} rows selected","buttonText":"Filter according to selected row(s)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();